<template>
  <div id="home">
    <intro/>
    <popular-bundles/>
    <!--    <feature-controller/>-->
    <!--    <popular-bundles2/>-->
    <random-offers/>
    <MtnApps/>
    <special-services/>
    <mtn-app/>
  </div>
</template>

<script>
import Intro from '../Intro'
import PopularBundles from '../PopularBundles'
import RandomOffers from '../RandomOffers'
import MtnApps from '../MtnApps'
import SpecialServices from '../SpecialServices'
import MtnApp from '../CommercialApp'
export default {
  name: 'Home',
  components: { MtnApp, SpecialServices, MtnApps, RandomOffers, PopularBundles, Intro }
}
</script>

<style scoped>

</style>
